import { render } from "./DeclarantsPage.vue?vue&type=template&id=de0fbfb2&scoped=true"
import script from "./DeclarantsPage.vue?vue&type=script&lang=js"
export * from "./DeclarantsPage.vue?vue&type=script&lang=js"

import "./DeclarantsPage.vue?vue&type=style&index=0&id=de0fbfb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de0fbfb2"]])

export default __exports__